import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      title: 'Canada',
      title_main: 'Kanada',
      title_sub: 'Etkinlik Yönetim Sistemi',
      login: 'Giriş Yap',
      username: 'Kullanıcı Adı',
      password: 'Şifre',
      checkIn: 'Check-In',
      participants: 'Katılımcılar',
      volunteers: 'Gönüllüler',
      volunteerFields: 'Gönüllü Alanları',
      volunteersFetchFailed: 'Gönüllüler alınamadı',
      exportVolunteersMessage: 'Gönüllü listesini Excel dosyası olarak indirmek istediğinizden emin misiniz?',
      users: 'Kullanıcılar',
      eventSettings: 'Davetli Ayarları',
      adminSettings: 'Yönetici Ayarları',
      logout: 'Çıkış Yap',
      firstName: 'Ad',
      lastName: 'Soyad',
      email: 'E-posta',
      qrId: 'QR ID',
      plusOneQrId: 'Artı Bir QR ID',
      plusOneCount: 'Artı Bir Sayısı',
      selectGuestType: 'Davetli Türü Seç',
      allGuests: 'Tüm Davetliler',
      guestType: 'Davetli Türü',
      responded: 'Yanıt Verdi',
      willAttend: 'Katılacağım',
      isCheckedIn: 'Check-In Durumu',
      checkInTime: 'Check-In Zamanı',
      actions: 'İşlemler',
      delete: 'Sil',
      deleteSuccess: 'Davetli başarıyla silindi',
      deleteFailed: 'Davetli silinemedi',
      confirmDelete: 'Bu davetliyi silmek istediğinizden emin misiniz?',
      confirmDeleteWithPlusOne: 'Bu davetliyi silmek, ilişkili Artı Bir davetlisini de silecektir. Devam etmek istiyor musunuz?',
      confirmBulkDeleteWithPlusOne: 'Seçilen davetliler ve ilişkili Artı Bir davetlileri silinecektir. Onaylıyor musunuz?',
      edit: 'Düzenle',
      editParticipant: 'Davetliyi Düzenle',
      invitedGuest: 'Davet Edilen Davetli',
      removeInvited: 'Kaldır',
      confirmRemoveInvited: 'Bu işlem, davetliyi ve davet ettiği tüm Artı Bir davetlileri silecektir. Devam etmek istiyor musunuz?',
      removeInvitedSuccess: 'Davetli ve davet edilen Artı Bir davetliler başarıyla kaldırıldı',
      removeInvitedSuccessNoPlusOne: 'Davet edilen Artı Bir davetli bulunamadı, ancak referans başarıyla temizlendi',
      removeInvitedFailed: 'Davet edilen davetli silinemedi',
      add: 'Ekle',
      addParticipant: 'Davetli Ekle',
      confirmAddGuest: 'Bu davetliyi eklemek istediğinizden emin misiniz?',
      participantAdded: 'Davetli eklendi',
      addGuestFailed: 'Davetli eklenemedi',
      confirmAddPlusOne: 'Bu Artı Bir davetlisini ve davet eden kişiyi hem Davetli hem Katılımcı tablolarına eklemek istediğinizden emin misiniz?',
      addPlusOneSuccess: 'Artı Bir davetli başarıyla eklendi',
      participantsUploaded: 'Katılımcılar yüklendi',
      participantList: 'Davetli Listesi',
      search: 'Ara',
      searchPlaceholder: 'Ad, soyad veya e-posta ile ara',
      previous: 'Önceki',
      next: 'Sonraki',
      error: 'Hata',
      participantInfo: 'Davetli Bilgileri',
      uploadExcel: 'Excel Dosyası Yükle',
      uploadGuests: 'Davetli Yükle',
      startScanning: 'Taramayı Başlat',
      stopScanning: 'Taramayı Durdur',
      save: 'Kaydet',
      participantUpdated: 'Davetli başarıyla güncellendi',
      empty_fields: 'Tüm alanlar zorunludur!',
      close_button: 'Kapat',
      yes: 'Evet',
      no: 'Hayır',
      none: 'Yok',
      usersPlaceholder: 'Kullanıcı yönetimi henüz uygulanmadı.',
      allRightsReserved: 'Tüm hakları saklıdır.',
      deleteSelected: 'Seçilenleri Sil',
      confirmBulkDelete: 'Seçtiğiniz satırlar silinecektir. Onaylıyor musunuz?',
      bulkDeleteSuccess: 'Seçilen davetliler başarıyla silindi',
      confirmAction: 'Bu işlemi gerçekleştirmek istediğinize emin misiniz?',
      confirm: 'Onayla',
      cancel: 'İptal',
      exportToExcel: 'Excel\'e Aktar',
      generateReport: 'Rapor Oluştur',
      exportToPDF: 'PDF Olarak Aktar',
      participantReport: 'Davetli Raporu',
      statistics: 'İstatistikler',
      metric: 'Metrik',
      value: 'Değer',
      checkedIn: 'Giriş Yapan',
      notCheckedIn: 'Giriş Yapmayan',
      totalParticipants: 'Toplam Davetli',
      checkInPieChart: 'Giriş Durumu Pasta Grafiği',
      checkInTimeGraph: 'Zamana Bağlı Giriş Grafiği',
      numberOfCheckIns: 'Giriş Sayısı',
      hour: 'Saat',
      alreadyCheckedIn: 'Bu kişi daha önce check-in yapmıştır',
      confirmDeleteParticipant: 'Bu davetliyi silmek istediğinizden emin misiniz?',
      manualCheckIn: 'Manuel Check-In',
      checkInSuccess: 'Davetli check-in yaptı.',
      importParticipants: 'Davetlileri İçe Aktar',
      deleteExistingParticipants: 'Mevcut katılımcıları sil',
      keepExistingParticipants: 'Mevcut katılımcıları koru',
      continue: 'Devam Et',
      dragDropOrClick: 'Excel dosyasını buraya sürükleyip bırakın veya seçmek için tıklayın',
      dropFileHere: 'Dosyayı buraya bırakın',
      resetCheckIns: 'Check-In Durumlarını Sıfırla',
      checkInsReset: 'Tüm check-in durumları sıfırlandı',
      deleteAllParticipants: 'Tüm Katılımcıları Sil',
      allParticipantsDeleted: 'Tüm katılımcılar silindi',
      uploadFailed: 'Dosya yüklenemedi',
      resetCheckInsFailed: 'Check-in durumları sıfırlanamadı',
      deleteParticipantsFailed: 'Katılımcılar silinemedi',
      invalidFileType: 'Geçersiz dosya türü. Lütfen bir .xlsx veya .xls dosyası yükleyin.',
      invitationTitle: 'Etkinlik Davetiyesi',
      welcome: 'Hoş geldiniz',
      yourQrId: 'Sizin QR ID\'niz',
      downloadPDF: 'PDF İndir',
      guestNotFound: 'Davetli bulunamadı',
      invitationNotAvailable: 'Davetiye mevcut değil',
      loading: 'Yükleniyor...',
      noGuestsFound: 'Davetli bulunamadı',
      participant: 'Katılımcı',
      employee: 'Çalışan',
      vip: 'VIP',
      plusOne: 'Artı Bir',
      regular: 'Normal',
      attending: 'Katılacağım',
      not_attending: 'Katılmayacağım',
      add_plus_one: 'Artı Bir Ekle',
      plus_one_name: 'Artı Bir Adı',
      plus_one_surname: 'Artı Bir Soyadı',
      submit_plus_one: 'Artı Bir Kaydet',
      rsvp_confirmed: 'Katılımınız Onaylandı',
      rsvp_confirmation_message: 'Etkinliğe katılımınız başarıyla kaydedildi. Teşekkür ederiz!',
      back_to_home: 'Ana Sayfaya Dön',
      serverError: 'Sunucu hatası oluştu',
      alreadyRegistered: 'Bu davetli zaten kaydedilmiş',
      rsvp_not_attending: 'Katılmayacak olarak kaydedildi',
      please_complete_recaptcha: 'Lütfen reCAPTCHA\'yı tamamlayın',
      invalid_recaptcha: 'Geçersiz reCAPTCHA doğrulama',
      error_fetching_invitation: 'Davetiye bilgileri alınamadı',
      error_rsvp: 'RSVP işlemi başarısız',
      confirmation: 'Katılım Onayı',
      confirmationTitle: 'Onay',
      verifyToContinue: 'Sayfayı görebilmek için doğrulamayı tamamlayın',
      toggleRsvp: 'RSVP Sistemini Aç/Kapat',
      rsvpToggled: 'RSVP durumu değiştirildi',
      resetAll: 'Tüm Verileri Sıfırla',
      allDataDeleted: 'Tüm veriler silindi',
      participantDeleted: 'Davetli silindi',
      rsvpEnabled: 'RSVP Sistemi Açık',
      rsvpDisabled: 'RSVP Sistemi Kapalı',
      rsvpStatusFetchFailed: 'RSVP durumu alınamadı',
      rsvpToggleFailed: 'RSVP durumu değiştirilemedi',
      failedRowsTitle: 'Hatalı Satırlar',
      failedRowsMessage: 'Bazı satırlar yüklenemedi. Lütfen aşağıdaki hataları düzeltin.',
      rowNumber: 'Satır Numarası',
      retry: 'Tekrar Dene',
      ignoreFailedRows: 'Hatalı Satırları Yoksay',
      retryFailed: 'Tekrar deneme başarısız oldu',
      invalidEmail: 'E-posta alanı eksik veya geçersiz, lütfen geçerli bir e-posta girin.',
      missingFirstName: 'Ad alanı eksik, lütfen doldurun (satır: {row})',
      missingLastName: 'Soyad alanı eksik, lütfen doldurun (satır: {row})',
      missingQrId: 'QR ID alanı eksik veya geçersiz, lütfen geçerli bir QR ID girin (satır: {row})',
      duplicateEmailInFile: 'Bu e-posta başka bir satırda kullanılıyor (satır: {row})',
      duplicateEmailInDb: 'Bu e-posta zaten veritabanında kayıtlı (satır: {row})',
      duplicateQrIdInDb: 'QR ID başka bir kullanıcı tarafından kullanılıyor. QR ID\'yi düzenleyin veya silin; silerseniz bu kullanıcı için otomatik olarak benzersiz bir QR ID oluşturulacaktır (satır: {row})',
      plusOneNotAllowed: 'Artı Bir türü davetliler Excel ile yüklenemez (satır: {row})',
      invalidGuestType: 'Geçersiz veya eksik davetli tipi (satır: {row})',
      resetEvent: 'Etkinliği Sonlandır',
      confirmResetPrompt: 'Etkinliği sıfırlamak ve tüm davetli ile kullanıcı verilerini silmek için aşağıya "sıfırla" yazın.',
      resetEventSuccess: 'Etkinlik başarıyla sıfırlandı. Tüm davetliler ve kullanıcılar silindi.',
      resetEventFailed: 'Etkinlik sıfırlanamadı.',
      invalidResetInput: 'Geçersiz giriş. Lütfen onaylamak için "sıfırla" yazın.',
      importGuests: 'Davetlileri İçe Aktar',
      deleteExistingGuests: 'Mevcut Davetlileri Sil',
      keepExistingGuests: 'Mevcut Davetlileri Koru',
      confirmEndEvent: 'Bu butona tıklandığında bütün davetli ve kullanıcı verileri silinecek.',
      eventEndSuccess: 'Etkinlik başarıyla sonlandırıldı ve tüm veriler silindi',
      eventEndFailed: 'Etkinlik sonlandırılamadı ve veriler silinemedi',
      endEvent: 'Etkinliği Sonlandır',
      invalidRowData: 'Geçersiz satır verisi',
      invalidLanguage: 'Desteklenmeyen dil',
      fileNotUploaded: 'Excel dosyası yüklenmedi',
      emptyFile: 'Excel dosyası boş',
      missingColumn: 'Gerekli kolon eksik: {key}',
      deleteExistingFailed: 'Mevcut davetliler silinirken bir hata oluştu',
      invalidRetryData: 'Geçerli satır verisi sağlanmadı',
      checkInFailed: 'Check-in işlemi başarısız',
      qrIdMissing: 'QR ID eksik',
      invalidUsername: 'Geçersiz kullanıcı adı',
      invalidPassword: 'Geçersiz şifre',
      guestAddFailed: 'Davetli eklenemedi',
      guestUpdateFailed: 'Güncelleme başarısız',
      guestDeleteFailed: 'Davetli silinemedi',
      invalidInviter: 'Geçersiz davet eden seçildi',
      maxGuestsReached: 'Maksimum 5 misafir ekleyebilirsiniz',
      addGuestPrompt: 'Misafir eklemek istiyorsanız, aşağıdaki formu doldurun:',
      submitGuest: 'Misafir Ekle',
      downloadGuestTicket: 'Misafir Biletini İndir',
      guestAddedSuccess: 'Misafir başarıyla eklendi',
      plusOneManagement: 'Artı Bir Yönetimi',
      addPlusOne: 'Artı Bir Ekle',
      plusOneAdded: 'Artı bir başarıyla eklendi',
      plusOneAddFailed: 'Artı bir eklenemedi',
      plusOneUpdated: 'Artı bir başarıyla güncellendi',
      plusOneUpdateFailed: 'Artı bir güncellenemedi',
      plusOneDeleted: 'Artı bir başarıyla silindi',
      plusOneDeleteFailed: 'Artı bir silinemedi',
      plusOnesFetchFailed: 'Artı birler alınamadı',
      noPlusOnes: 'Henüz artı bir bulunmuyor',
      close: 'Kapat',

      guestsFetchFailed: 'Davetliler alınamadı',
      invitersFetchFailed: 'Davet edenler alınamadı',
      guestTypeSettings: 'Davetli Türü Ayarları',
      guestTypeSettingsDescription: 'Her davetli türünün kaç tane misafir çağırabileceğini ayarlayın:',
      guestTypeSettingsSaved: 'Davetli türü ayarları başarıyla kaydedildi',
      guestTypeSettingsSaveFailed: 'Davetli türü ayarları kaydedilemedi',
      guestTypeSettingsFetchFailed: 'Davetli türü ayarları alınamadı',
      invalidGuestTypeSetting: 'Geçersiz davetli türü ayarı',
      maxGuestsReached: 'Bu davet eden için maksimum misafir sayısına ulaşıldı',
      plusOneRequiresInviter: 'Plus One misafir türü için bir davet eden seçilmesi gerekiyor',
      invalidInviter: 'Seçilen davet eden geçerli değil veya misafir davet etme izni yok',
      addUser: 'Kullanıcı Ekle',
      editUser: 'Kullanıcı Düzenle',
      usernameRequired: 'Kullanıcı adı gerekli',
      passwordRequired: 'Şifre gerekli',
      rolesRequired: 'En az bir rol seçilmeli',
      userUpdateSuccess: 'Kullanıcı başarıyla güncellendi',
      userAddSuccess: 'Kullanıcı başarıyla eklendi',
      userDeleteSuccess: 'Kullanıcı başarıyla silindi',
      userDeleteFailed: 'Kullanıcı silinemedi',
      operationFailed: 'İşlem başarısız',
      confirmDeleteUser: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
      admin: 'Yönetici',
      editor: 'Editör',
      usereditor: 'Kullanıcı Editörü',
      guesteditor: 'Davetli Editörü',
      participanteditor: 'Katılımcı Editörü',
      checkineditor: 'Check-In Editörü',
      roles: 'Roller',
      createdAt: 'Oluşturulma Tarihi',
      unauthorized: 'Yetkisiz erişim',
      homeDescription: 'Kanada Etkinlik Yönetim Sistemi\'ne hoş geldiniz! Bu platform, davetli yönetimi, check-in işlemleri, RSVP takibi ve kullanıcı rol tabanlı erişim kontrolü gibi özelliklerle etkinlik organizasyonunu kolaylaştırır. Yönetici, editör veya check-in personeli olsanız da, sistemimiz etkinlikleri verimli bir şekilde yönetmek için sorunsuz bir deneyim sunar.',
      session_expired: 'Oturum süreniz doldu. Lütfen tekrar giriş yapın.',
      uploadSuccess: '{count} davetli başarıyla yüklendi',
      plusOneQrId_required: 'Artı Bir türü için davet eden kişinin QR ID\'si zorunludur',
      inviter_required: 'Artı Bir türü için bir davet eden seçilmelidir',
      selectInviter: 'Davet Eden Seçin',
      inviter_already_has_plus_one: 'Bu davet edenin zaten bir Artı Bir davetlisi var',
      noInvitersAvailable: 'Uygun davet eden bulunamadı',
      confirmAttend: 'Davetli Katılımcılar listesine eklenecektir.',
      invitationHeader: 'Kanada Günü münasebetiyle Kanada Büyükelçisi',
      ambassador: 'Sayın Kevin Hamilton ve Bayan Tal Hamilton',
      requestPresence: 'Resepsiyonun keyfini çıkarmayı rica eder',
      eventDetails: '1 Temmuz 2025 Salı 18:30-22:00',
      location: 'Resmi Konut, Turan Emeksiz 13, G.O.P',
      rsvpEmail: 'Soru için',
      downloadTicketPrompt: 'Aşağıdaki butona tıklayıp biletinizi indirebilirsiniz.',
      downloadTicket: 'Bileti İndir',
      plusOneTicketPrompt: '{firstName} {lastName} adlı davetlinizin biletine buradan ulaşabilirsiniz.',
      downloadPlusOneTicket: 'Davetli Biletini İndir',
      addPlusOnePrompt: 'Eğer bir davetli getiriyorsanız, lütfen aşağıdaki formu doldurun:',
      guestFirstName: 'Davetli Adı',
      guestLastName: 'Davetli Soyadı',
      guestEmail: 'Davetli E-posta',
      submitGuestInfo: 'Davetli Bilgilerini Gönder',
      continueWithoutGuest: 'Davetli eklemeden devam et',
      dressCode: 'Kıyafet Kodu: İş kıyafeti; Ulusal kıyafet ve askeri üniforma kabul edilir.',
      qrCodeNotice: 'Lütfen girişte biletinizi ve kimliğinizi gösterin.',
      noParking: 'Park yeri mevcut değildir. Bu davetiye devredilemez.',
      noMinors: 'Küçükler kabul edilmez.',
      telegramStatusFetchFailed: 'Telegram durumu alınamadı',
      telegramToggleFailed: 'Telegram durumu değiştirilemedi',
      telegramToggled: 'Telegram bildirimleri durumu güncellendi',
      telegramEnabled: 'Telegram Mesajları Açık',
      telegramDisabled: 'Telegram Mesajları Kapalı',
      toggleTelegram: 'Telegram Mesajlarını Aç/Kapat',
      confirmNotAttend: 'Davetlinin katılmayacağını onayla.',
      declineMessage: 'Sizleri aramızda göremeyeceğimiz için üzgünüz.',
      downloadOwnTicket: 'Biletim',
      submitPlusOne: 'Davetlimi Ekle',

      retryOrContact: 'Lütfen sayfayı yenileyip tekrar deneyiniz. Eğer hata devam ediyorsa ankara.rsvp@international.gc.ca adresini kullanarak bizimle iletişime geçiniz.',
      rsvpClosedMessage: 'Üzgünüz fakat kayıtlarımız sona ermiştir. Talep ve sorularınız için ile iletişime geçebilirsiniz.',
      participantLimitReached: 'Katilimci limiti doldugu icin RSVP kapatildi.',
      openRsvpLink: 'Davetiye linkini aç',
      unknownGuest: 'Bilinmeyen Davetli',
      excelHeadersInstruction: 'Tablonun şu başlıkları içerdiğinden emin olun: Ad, Soyad, E-posta, Davetli Türü',
      deleteAllGuests: 'Tüm Davetlileri Sil',
      verifyPrompt: 'Lütfen doğrulayınız',
      turnstileVerificationFailed: 'Doğrulama başarısız oldu, lütfen tekrar deneyin.',
      confirmUpdateGuest:"Misafirin bilgileri değiştirilecektir.",
      attend: "Katılacağım",
      notAttend: "Katılmayacağım",
      invalid_credentials: "Kullanıcı adı veya şifre hatalı",
      guestsFirstName: "Misafirinizin Adı",
      guestsLastName: "Misafirinizin Soyadı",
      guestsEmail: "Misafirinizin E-postası",
      missingFields: "Lütfen eksik alanları doldurunuz",
      plusone: "Artı Bir",
      
      
      willAttendCount: "Katılacağını Belirtenler",
      rsvpResponseRate: "Davetiyeye Cevap Verenler",
      employeeCount: "Personellerin Sayısı",
      regularCount:  "Genel Davetlilerin Sayısı",
      vipCount: "VIP Sayısı",
      plusOneCount: "Artı Birlerin Sayısı",
      checkInPieChartDescription: "Bu grafik davetlilerin kaçının katılım sağladığını gösterir.",
      guestTypeDistribution: "Davetli Türü Dağılımı",
      guestTypeDistributionDescription: "Davetlilerin türlerine göre dağılımlarını gösterir.",
      checkIns: "Katılım Sağlayanlar",
      checkInTimeGraphDescription: "Davetlilerin zamana göre katılım dağılımlarını gösterir.",
      rsvpResponseChart: "Davetiye Yanıtlama Grafiği",
      notResponded: "Yanıtlanmadı.",
      rsvpResponseChartDescription: "Davetiye Yanıtlama Grafiği",
      loading: "Sayfa Yükleniyor",
      processing: "İşleniyor...",
      selectGuestType: "Misafir Türünü Seçin",
      allGuests: "Tüm Misafirler",
      export: "Dışa Aktar",
      invitedGuestInfo: "Davet Edilen Misafir Bilgileri",
      addGuest: 'Misafir Ekle',
      eventTitle: "Canada Club'un HALLOWEEN PARTİSİ",
      eventName: "Canada Club'un HALLOWEEN PARTİSİ",
      dear: "Sayın",
      invitationLine: "Canada Club'un Halloween Partisine davetlisiniz",
      invitationLinePrefix: "Canada Club'un",
      foodAndBeverage: "Yiyecek ve içecekler ücretli olarak satın alınabilir",
      eventDate: "Cuma, 31 Ekim 2025",
      eventTime: "18:00 - 22:00",
      eventLocation: "Ankara'daki Kanada Büyükelçiliği'nde",
      registrationOpen: "",
      spaceLimited: "",
      noParking: "Park yeri bulunmamaktadır.",
      drinkResponsibly: "Sorumlu içmeyi unutmayın; içip araç kullanmayın.",
      sociallyYours: "Saygılarımızla,",
      pdfError: "PDF oluşturulamadı, lütfen tekrar deneyin.",
      rsvpStatusError: "RSVP durumu alınamadı, lütfen daha sonra tekrar deneyin.",
      additionalGuestsInfo: "RSVP yaptıktan sonra, ek misafir davet etmek için ikinci bir e-posta alacaksınız. Misafir davet eden herkesin etkinlikte onlara eşlik etmek için orada bulunması gerektiğini lütfen unutmayın.",
      doNotShareLink: "Lütfen şimdi buradan kayıt olun. Bu bağlantıyı kimseyle paylaşmayın.",
      upTo6GuestsInfo: "RSVP yaptıktan sonra, 6 misafire kadar davet etmek için ikinci bir e-posta alacaksınız. Misafir davet eden herkesin etkinlikte onlara eşlik etmek için orada bulunması gerektiğini lütfen unutmayın.",
      volunteerSettings: 'Volunteer Ayarları',
      volunteerSettingsDescription: 'Volunteer tiplerini ekleyin, düzenleyin veya silin:',
      volunteerNamePlaceholder: 'Örn: bartender, token sale',
      addVolunteer: 'Yeni Volunteer Ekle',
      fillEmptyVolunteerField: 'Lütfen boş alanları doldurun',
      fillAllVolunteerFields: 'Lütfen tüm alanları doldurun',
      volunteerSettingsSaved: 'Volunteer ayarları başarıyla kaydedildi',
      volunteerSettingsSaveFailed: 'Volunteer ayarları kaydedilemedi',
      volunteerSettingsFetchFailed: 'Volunteer ayarları alınamadı',
      noVolunteers: 'Henüz volunteer eklenmemiş. Aşağıdaki artı butonuna tıklayarak ekleyebilirsiniz.',
      invalidVolunteerSettings: 'Geçersiz volunteer ayarları',
      invalidVolunteerName: 'Geçersiz volunteer adı',
      toggleVolunteerSystem: 'Volunteer System',
      volunteerSystemToggled: 'Volunteer System {status}',
      volunteerSystemToggleFailed: 'Volunteer system durumu değiştirilemedi',
      volunteerSystemStatusFetchFailed: 'Volunteer system durumu alınamadı',
      enabled: 'Açık',
      disabled: 'Kapalı',
      eventInformationSettings: 'Etkinlik Bilgileri Ayarları',
      eventInformationSettingsDescription: 'Etkinlik bilgilerini girin:',
      eventNameLabel: 'Etkinlik Adı',
      eventDateLabel: 'Etkinlik Tarihi',
      eventTimeLabel: 'Etkinlik Saati',
      eventLocationLabel: 'Etkinlik Yeri',
      eventAddressLabel: 'Etkinlik Adresi',
      eventWaiverLabel: 'Onay Kutusu Metni',
      eventNamePlaceholder: 'Örn: HALLOWEEN PARTY',
      eventAddressPlaceholder: 'Örn: Aziziye, Cinnah Street no: 58, 06690 Çankaya/Ankara',
      eventDatePlaceholder: 'Örn: Cuma, 31 Ekim 2025',
      eventTimePlaceholder: 'Örn: 18:00 - 22:00',
      eventLocationPlaceholder: 'Örn: Ankara\'daki Kanada Büyükelçiliği\'nde',
      eventInformationSaved: 'Etkinlik bilgileri başarıyla kaydedildi',
      eventInformationSaveFailed: 'Etkinlik bilgileri kaydedilemedi',
      eventInformationFetchFailed: 'Etkinlik bilgileri alınamadı',
      invalidEventInformation: 'Tüm alanlar doldurulmalıdır',
      fillAllFields: 'Lütfen tüm alanları doldurun',
      wouldYouLikeToVolunteer: 'Gönüllü olmak ister misiniz?',
      yes: 'Evet',
      no: 'Hayır',
    },
  },
  en: {
    translation: {
      title: 'Canada',
      title_main: 'Canada',
      title_sub: 'Event Management System',
      login: 'Log In',
      username: 'Username',
      password: 'Password',
      checkIn: 'Check-In',
      participants: 'Participants',
      volunteers: 'Volunteers',
      volunteerFields: 'Volunteer Fields',
      volunteersFetchFailed: 'Failed to fetch volunteers',
      exportVolunteersMessage: 'Are you sure you want to export the volunteer list to Excel?',
      users: 'Users',
      eventSettings: 'Invitee Settings',
      adminSettings: 'Admin Settings',
      logout: 'Log Out',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      qrId: 'QR ID',
      plusOneQrId: 'Plus One QR ID',
      selectGuestType: 'Select Guest Type',
      allGuests: 'All Guests',
      guestType: 'Guest Type',
      responded: 'Responded',
      willAttend: 'Will Attend',
      isCheckedIn: 'Check-In Status',
      checkInTime: 'Check-In Time',
      actions: 'Actions',
      delete: 'Delete',
      deleteSuccess: 'Guest deleted successfully',
      deleteFailed: 'Failed to delete guest',
      confirmDelete: 'Are you sure you want to delete this guest?',
      confirmDeleteWithPlusOne: 'Deleting this guest will also delete their associated Plus One guest. Do you want to proceed?',
      confirmBulkDeleteWithPlusOne: 'The selected guests and their associated Plus One guests will be deleted. Do you confirm?',
      edit: 'Edit',
      editParticipant: 'Edit Guest',
      invitedGuest: 'Invited Guest',
      removeInvited: 'Remove',
      confirmRemoveInvited: 'This will delete the guest and all invited Plus One guests. Do you want to continue?',
      removeInvitedSuccess: 'Guest and invited Plus One guests removed successfully',
      removeInvitedSuccessNoPlusOne: 'Invited Plus One guest not found, but reference was successfully cleared',
      removeInvitedFailed: 'Failed to delete invited guest',
      add: 'Add',
      addParticipant: 'Add Guest',
      confirmAddGuest: 'Are you sure you want to add this guest?',
      participantAdded: 'Guest added',
      addGuestFailed: 'Failed to add guest',
      confirmAddPlusOne: 'Are you sure you want to add this Plus One guest and the inviter to both Guest and Participant tables?',
      addPlusOneSuccess: 'Plus One guest successfully added',
      participantsUploaded: 'Participants uploaded',
      participantList: 'Guest List',
      search: 'Search',
      searchPlaceholder: 'Search by first name, last name, or email',
      previous: 'Previous',
      next: 'Next',
      error: 'Error',
      participantInfo: 'Guest Information',
      uploadExcel: 'Upload Excel File',
      uploadGuests: 'Upload Guests',
      startScanning: 'Start Scanning',
      stopScanning: 'Stop Scanning',
      save: 'Save',
      participantUpdated: 'Guest updated successfully',
      empty_fields: 'All fields are required!',
      close_button: 'Close',
      yes: 'Yes',
      no: 'No',
      none: 'None',
      usersPlaceholder: 'User management is not yet implemented.',
      allRightsReserved: 'All rights reserved.',
      deleteSelected: 'Delete Selected',
      confirmBulkDelete: 'The selected rows will be deleted. Are you sure?',
      bulkDeleteSuccess: 'Selected guests deleted successfully',
      confirmAction: 'Are you sure you want to perform this action?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      exportToExcel: 'Export to Excel',
      generateReport: 'Generate Report',
      exportToPDF: 'Export as PDF',
      participantReport: 'Guest Report',
      statistics: 'Statistics',
      metric: 'Metric',
      value: 'Value',
      checkedIn: 'Checked In',
      notCheckedIn: 'Not Checked In',
      totalParticipants: 'Total Guests',
      checkInPieChart: 'Check-In Status Pie Chart',
      checkInTimeGraph: 'Time-Based Check-In Graph',
      numberOfCheckIns: 'Number of Check-Ins',
      hour: 'Hour',
      alreadyCheckedIn: 'This person has already checked in',
      confirmDeleteParticipant: 'Are you sure you want to delete this guest?',
      manualCheckIn: 'Manual Check-In',
      checkInSuccess: 'Guest checked in successfully.',
      importParticipants: 'Import Guests',
      deleteExistingParticipants: 'Delete existing participants',
      keepExistingParticipants: 'Keep existing participants',
      continue: 'Continue',
      dragDropOrClick: 'Drag and drop an Excel file here, or click to select one',
      dropFileHere: 'Drop the file here',
      resetCheckIns: 'Reset Check-In Statuses',
      checkInsReset: 'All check-in statuses have been reset',
      deleteAllParticipants: 'Delete All Participants',
      allParticipantsDeleted: 'All participants have been deleted',
      uploadFailed: 'File upload failed',
      resetCheckInsFailed: 'Failed to reset check-in statuses',
      deleteParticipantsFailed: 'Participants could not be deleted',
      invalidFileType: 'Invalid file type. Please upload a .xlsx or .xls file.',
      invitationTitle: 'Event Invitation',
      welcome: 'Welcome',
      yourQrId: 'Your QR ID',
      downloadPDF: 'Download PDF',
      guestNotFound: 'Guest not found',
      invitationNotAvailable: 'Invitation not available',
      loading: 'Loading...',
      noGuestsFound: 'No guests found',
      participant: 'Participant',
      employee: 'Employee',
      vip: 'VIP',
      plusOne: 'Plus One',
      regular: 'Regular',
      attending: 'I will attend',
      not_attending: 'I will not attend',
      add_plus_one: 'Add Plus One',
      plus_one_name: 'Plus One Name',
      plus_one_surname: 'Plus One Surname',
      submit_plus_one: 'Save Plus One',
      rsvp_confirmed: 'Your Attendance is Confirmed',
      rsvp_confirmation_message: 'Your attendance to the event has been successfully recorded. Thank you!',
      back_to_home: 'Back to Home',
      serverError: 'Server error occurred',
      alreadyRegistered: 'This guest is already registered',
      rsvp_not_attending: 'Recorded as not attending',
      please_complete_recaptcha: 'Please complete the reCAPTCHA',
      invalid_recaptcha: 'Invalid reCAPTCHA verification',
      error_fetching_invitation: 'Could not fetch invitation details',
      error_rsvp: 'RSVP failed',
      confirmation: 'Attendance Confirmation',
      confirmationTitle: 'Confirmation',
      verifyToContinue: 'Please complete the verification to view the page',
      toggleRsvp: 'Toggle RSVP System',
      rsvpToggled: 'The RSVP status has been changed.',
      resetAll: 'Reset All Data',
      allDataDeleted: 'All data deleted',
      participantDeleted: 'Guest deleted',
      rsvpEnabled: 'RSVP System Enabled',
      rsvpDisabled: 'RSVP System Disabled',
      rsvpStatusFetchFailed: 'Failed to fetch RSVP status',
      rsvpToggleFailed: 'Failed to toggle RSVP status',
      failedRowsTitle: 'Failed Rows',
      failedRowsMessage: 'Some rows failed to upload. Please correct the errors below.',
      rowNumber: 'Row Number',
      retry: 'Retry',
      ignoreFailedRows: 'Ignore Failed Rows',
      retryFailed: 'Retry failed',
      invalidEmail: 'Invalid or missing email address.',
      missingFirstName: 'Missing first name in row {row}',
      missingLastName: 'Missing last name in row {row}',
      missingQrId: 'Missing or invalid QR ID in row {row}',
      duplicateEmailInFile: 'This email is used in another row in the file (row: {row})',
      duplicateEmailInDb: 'This email is already registered in the database (row: {row})',
      duplicateQrIdInDb: 'QR ID is already used by another user. Edit the QR ID or remove it; if removed, a unique QR ID will be automatically generated for this user (row: {row})',
      plusOneNotAllowed: 'Plus One guests cannot be uploaded via Excel (row: {row})',
      invalidGuestType: 'Invalid or missing guest type in row {row}',
      resetEvent: 'End Event',
      confirmResetPrompt: 'To reset the event and delete all guest and user data, type "reset" below.',
      resetEventSuccess: 'Event successfully reset. All guests and users deleted.',
      resetEventFailed: 'Failed to reset event.',
      invalidResetInput: 'Invalid input. Please type "reset" to confirm.',
      importGuests: 'Import Guests',
      deleteExistingGuests: 'Delete Existing Guests',
      keepExistingGuests: 'Keep Existing Guests',
      confirmEndEvent: 'Clicking this button will delete all guest and user data.',
      eventEndSuccess: 'Event successfully ended and all data deleted',
      eventEndFailed: 'Failed to end event and delete data',
      endEvent: 'End Event',
      invalidRowData: 'Invalid row data',
      invalidLanguage: 'Unsupported language',
      plusOneManagement: 'Plus One Management',
      addPlusOne: 'Add Plus One',
      plusOneAdded: 'Plus one added successfully',
      plusOneAddFailed: 'Failed to add plus one',
      plusOneUpdated: 'Plus one updated successfully',
      plusOneUpdateFailed: 'Failed to update plus one',
      plusOneDeleted: 'Plus one deleted successfully',
      plusOneDeleteFailed: 'Failed to delete plus one',
      plusOnesFetchFailed: 'Failed to fetch plus ones',
      noPlusOnes: 'No plus ones yet',
      close: 'Close',
      fileNotUploaded: 'Excel file not uploaded',
      emptyFile: 'Excel file is empty',
      missingColumn: 'Required column missing: {key}',
      deleteExistingFailed: 'Failed to delete existing guests',
      invalidRetryData: 'Invalid row data provided for retry',
      checkInFailed: 'Check-in failed',
      qrIdMissing: 'QR ID is missing',
      invalidUsername: 'Invalid username',
      invalidPassword: 'Invalid password',
      guestAddFailed: 'Failed to add guest',
      guestUpdateFailed: 'Update failed',
      guestDeleteFailed: 'Failed to delete guest',
      maxGuestsReached: 'You can add a maximum of 5 guests',
      addGuestPrompt: 'If you are bringing guests, please fill out the form below:',
      submitGuest: 'Add Guest',
      downloadGuestTicket: 'Download Guest Ticket',
      guestAddedSuccess: 'Guest added successfully',
      guestsFetchFailed: 'Failed to fetch guests',
      invitersFetchFailed: 'Failed to fetch inviters',
      guestTypeSettings: 'Guest Type Settings',
      guestTypeSettingsDescription: 'Configure how many guests each guest type can invite:',
      guestTypeSettingsSaved: 'Guest type settings saved successfully',
      guestTypeSettingsSaveFailed: 'Failed to save guest type settings',
      guestTypeSettingsFetchFailed: 'Failed to fetch guest type settings',
      invalidGuestTypeSetting: 'Invalid guest type setting',
      maxGuestsReached: 'Maximum number of guests reached for this inviter',
      plusOneRequiresInviter: 'Plus One guest type requires an inviter to be selected',
      invalidInviter: 'Selected inviter is not valid or does not have permission to invite guests',
      addUser: 'Add User',
      editUser: 'Edit User',
      usernameRequired: 'Username is required',
      passwordRequired: 'Password is required',
      rolesRequired: 'At least one role must be selected',
      userUpdateSuccess: 'User updated successfully',
      userAddSuccess: 'User added successfully',
      userDeleteSuccess: 'User deleted successfully',
      userDeleteFailed: 'Failed to delete user',
      operationFailed: 'Operation failed',
      confirmDeleteUser: 'Are you sure you want to delete this user?',
      admin: 'Administrator',
      editor: 'Editor',
      usereditor: 'User Editor',
      guesteditor: 'Guest Editor',
      participanteditor: 'Participant Editor',
      checkineditor: 'Check-In Editor',
      roles: 'Roles',
      createdAt: 'Created At',
      unauthorized: 'Unauthorized access',
      homeDescription: 'Welcome to the Canada Event Management System! This platform streamlines event organization with features like guest management, check-in processes, RSVP tracking, and user role-based access control. Whether you are an admin, editor, or check-in staff, our system ensures a seamless experience for managing events efficiently.',
      session_expired: 'Your session has expired. Please log in again.',
      uploadSuccess: '{count} guests successfully uploaded',
      plusOneQrId_required: 'For the Plus One type, the inviter\'s QR ID is mandatory.',
      inviter_required: 'An inviter must be selected for the Plus One type',
      selectInviter: 'Select Inviter',
      inviter_already_has_plus_one: 'This inviter already has a Plus One guest',
      noInvitersAvailable: 'No suitable inviters found',
      confirmAttend: 'The invitee will be added to the Participants list.',
      invitationHeader: "On the occasion of Canada Day, the Ambassador of Canada",
      ambassador: 'H.E. Kevin Hamilton and Mrs. Tal Hamilton',
      requestPresence: 'request the pleasure of the company of',
      eventDetails: '18:30 to 22:00 Tuesday, 1 July 2025',
      location: 'Official Residence, Turan Emeksiz 13, G.O.P',
      rsvpEmail: 'For your questions',
      downloadTicketPrompt: 'Click the button below to download your ticket.',
      downloadTicket: 'Download Ticket',
      plusOneTicketPrompt: 'You can access your guest {firstName} {lastName}\'s ticket here.',
      downloadPlusOneTicket: 'Download Guest Ticket',
      addPlusOnePrompt: 'If you are bringing a guest, please fill out the form below:',
      guestFirstName: 'Guest First Name',
      guestLastName: 'Guest Last Name',
      guestEmail: 'Guest Email',
      submitGuestInfo: 'Submit Guest Info',
      continueWithoutGuest: 'Continue without adding a guest',
      dressCode: 'Dress code: Business attire; National dress and military uniform welcome.',
      qrCodeNotice: 'Please present your ticket and ID at the entrance.',
      noParking: 'No parking available. This invitation is non-transferable.',
      noMinors: 'No minors will be allowed.',
      telegramStatusFetchFailed: 'Failed to fetch Telegram status',
      telegramToggleFailed: 'Failed to toggle Telegram status',
      telegramToggled: 'Telegram notifications status updated',
      telegramEnabled: 'Telegram Messages Enabled',
      telegramDisabled: 'Telegram Messages Disabled',
      toggleTelegram: 'Toggle Telegram Messages',
      confirmNotAttend: 'Confirm that the invitee will not attend.',
      declineMessage: 'We are sorry that you will not be joining us.',
      downloadOwnTicket: 'My Ticket',
      submitPlusOne: 'Add My Guest',
      duplicateEmailInDb: 'This email address is already in use, please enter a different email.',
      retryOrContact: 'Please refresh the page and try again. If the error persists, contact us at ankara.rsvp@international.gc.ca.',
      rsvpClosedMessage: 'We’re sorry, but our registration has closed. For inquiries, please contact.',
      participantLimitReached: 'RSVP has been closed because the participant limit has been reached.',
      openRsvpLink: 'Open invitation link',
      unknownGuest: 'Unknown Guest',
      excelHeadersInstruction: 'Please ensure your table includes the following headers: First Name, Last Name, Email, Guest Type',
      deleteAllGuests: 'Delete All Guests',
      verifyPrompt: 'Please verify',
      turnstileVerificationFailed: 'Verification failed, please try again.',
      confirmUpdateGuest:"The guest's information will be changed.",
      attend: "I will attend",
      notAttend: "I will not attend",
      invalid_credentials: "Invalid username or password",
      guestsFirstName: "Your Guest's First Name",
      guestsLastName: "Your Guest's Last Name",
      guestsEmail: "Your Guest's Email",
      missingFields: "Please fill in the missing fields",
      plusone: "Plus One",
      willAttendCount: "Number of Attendees Confirmed",
      rsvpResponseRate: "RSVP Response Rate",
      employeeCount: "Number of Employees",
      regularCount: "Number of Regular Guests",
      vipCount: "Number of VIPs",
      plusOneCount: "Number of Plus Ones",
      checkInPieChartDescription: "This chart shows the number of guests who have checked in.",
      guestTypeDistribution: "Guest Type Distribution",
      guestTypeDistributionDescription: "Shows the distribution of guests by type.",
      checkIns: "Check-ins",
      checkInTimeGraphDescription: "Shows the distribution of guest check-ins over time.",
      rsvpResponseChart: "RSVP Response Chart",
      notResponded: "Not Responded",
      rsvpResponseChartDescription: "RSVP Response Chart",
      loading: "Page Loading",
      processing: "Processing...",
      export: "Export",
      invitedGuestInfo: "Invited Guest Information",
      addGuest: 'Add Guest',
      eventTitle: "Canada Club's HALLOWEEN PARTY",
      eventName: "Canada Club's HALLOWEEN PARTY",
      dear: "Dear",
      invitationLine: "You are invited to Canada Club's HALLOWEEN PARTY",
      invitationLinePrefix: "You are invited to Canada Club's",
      foodAndBeverage: "Food and beverages available for cash purchase",
      eventDate: "Friday October 31, 2025",
      eventTime: "18:00 - 22:00",
      eventLocation: "At the Canadian Embassy in Ankara",
      registrationOpen: "",
      spaceLimited: "",
      noParking: "There is no parking available.",
      drinkResponsibly: "Remember to drink responsibly; don't drink and drive.",
      sociallyYours: "Socially yours,",
      pdfError: "PDF could not be created, please try again.",
      rsvpStatusError: "RSVP status could not be retrieved, please try again later.",
      additionalGuestsInfo: "Once you RSVP, you will receive a second email to invite additional guests. Please remember that anyone inviting guests must be present to accompany them at the event.",
      doNotShareLink: "Please register here now. Do not share this link with anyone.",
      upTo6GuestsInfo: "Once you RSVP, you will receive a second email to invite up to 6 guests. Please remember that anyone inviting guests must be present to accompany them at the event.",
      volunteerSettings: 'Volunteer Settings',
      volunteerSettingsDescription: 'Add, edit, or delete volunteer types:',
      volunteerNamePlaceholder: 'E.g: bartender, token sale',
      addVolunteer: 'Add New Volunteer',
      fillEmptyVolunteerField: 'Please fill in empty fields',
      fillAllVolunteerFields: 'Please fill in all fields',
      volunteerSettingsSaved: 'Volunteer settings saved successfully',
      volunteerSettingsSaveFailed: 'Failed to save volunteer settings',
      volunteerSettingsFetchFailed: 'Failed to fetch volunteer settings',
      noVolunteers: 'No volunteers added yet. You can add them by clicking the plus button below.',
      invalidVolunteerSettings: 'Invalid volunteer settings',
      invalidVolunteerName: 'Invalid volunteer name',
      toggleVolunteerSystem: 'Volunteer System',
      volunteerSystemToggled: 'Volunteer System {status}',
      volunteerSystemToggleFailed: 'Failed to toggle volunteer system status',
      volunteerSystemStatusFetchFailed: 'Failed to fetch volunteer system status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      eventInformationSettings: 'Event Information Settings',
      eventInformationSettingsDescription: 'Enter event information:',
      eventNameLabel: 'Event Name',
      eventDateLabel: 'Event Date',
      eventTimeLabel: 'Event Time',
      eventLocationLabel: 'Event Location',
      eventAddressLabel: 'Event Address',
      eventWaiverLabel: 'Checkbox Text',
      eventNamePlaceholder: 'E.g: HALLOWEEN PARTY',
      eventAddressPlaceholder: 'E.g: Aziziye, Cinnah Street no: 58, 06690 Çankaya/Ankara',
      eventDatePlaceholder: 'E.g: Friday October 31, 2025',
      eventTimePlaceholder: 'E.g: 18:00 - 22:00',
      eventLocationPlaceholder: 'E.g: At the Canadian Embassy in Ankara',
      eventInformationSaved: 'Event information saved successfully',
      eventInformationSaveFailed: 'Failed to save event information',
      eventInformationFetchFailed: 'Failed to fetch event information',
      invalidEventInformation: 'All fields must be filled',
      fillAllFields: 'Please fill in all fields',
      wouldYouLikeToVolunteer: 'Would you like to volunteer?',
      yes: 'Yes',
      no: 'No',
    },
  },
  fr: {
    translation: {
      title: 'Canada',
      title_main: 'Canada',
      title_sub: 'Système de gestion d’événements',
      login: 'Se connecter',
      username: 'Nom d’utilisateur',
      password: 'Mot de passe',
      checkIn: 'Check-In',
      participants: 'Participants',
      volunteers: 'Bénévoles',
      volunteerFields: 'Domaines de bénévolat',
      volunteersFetchFailed: 'Échec de la récupération des bénévoles',
      exportVolunteersMessage: 'Êtes-vous sûr de vouloir exporter la liste des bénévoles vers Excel?',
      users: 'Utilisateurs',
      eventSettings: 'Paramètres des invités',
      adminSettings: 'Paramètres d’administration',
      logout: 'Déconnexion',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'E-mail',
      qrId: 'ID QR',
      plusOneQrId: 'ID QR Accompagnateur',
      guestType: 'Type d’invité',
      responded: 'A répondu',
      willAttend: 'Participera',
      isCheckedIn: 'Statut de check-in',
      checkInTime: 'Heure de check-in',
      actions: 'Actions',
      delete: 'Supprimer',
      deleteSuccess: 'Invité supprimé avec succès',
      deleteFailed: 'Échec de la suppression de l’invité',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet invité ?',
      confirmDeleteWithPlusOne: 'Supprimer cet invité supprimera également l’invité Accompagnateur associé. Voulez-vous continuer ?',
      confirmBulkDeleteWithPlusOne: 'Les invités sélectionnés et leurs invités Accompagnateurs associés seront supprimés. Confirmez-vous ?',
      edit: 'Modifier',
      editParticipant: 'Modifier l’invité',
      invitedGuest: 'Invité',
      removeInvited: 'Retirer',
      confirmRemoveInvited: 'Cela supprimera l’invité et tous les accompagnateurs associés (Accompagnateur). Voulez-vous continuer ?',
      removeInvitedSuccess: 'Invité et accompagnateurs associés supprimés avec succès',
      removeInvitedSuccessNoPlusOne: 'Invité Accompagnateur non trouvé, mais la référence a été supprimée avec succès',
      removeInvitedFailed: 'Échec de la suppression de l’invité',
      add: 'Ajouter',
      addParticipant: 'Ajouter un invité',
      confirmAddGuest: 'Êtes-vous sûr de vouloir ajouter cet invité ?',
      participantAdded: 'Invité ajouté',
      addGuestFailed: 'Échec de l’ajout de l’invité',
      confirmAddPlusOne: 'Êtes-vous sûr de vouloir ajouter cet invité Accompagnateur et l’invitant aux tables Invité et Participant ?',
      addPlusOneSuccess: 'Invité Accompagnateur ajouté avec succès',
      participantsUploaded: 'Participants téléchargés',
      participantList: 'Liste des invités',
      search: 'Rechercher',
      searchPlaceholder: 'Rechercher par prénom, nom de famille ou e-mail',
      previous: 'Précédent',
      next: 'Suivant',
      error: 'Erreur',
      participantInfo: 'Informations sur l’invité',
      uploadExcel: 'Télécharger un fichier Excel',
      uploadGuests: 'Télécharger des invités',
      startScanning: 'Démarrer le scan',
      stopScanning: 'Arrêter le scan',
      save: 'Enregistrer',
      participantUpdated: 'Invité mis à jour avec succès',
      empty_fields: 'Tous les champs sont requis !',
      close_button: 'Fermer',
      yes: 'Oui',
      no: 'Non',
      none: 'Aucun',
      usersPlaceholder: 'La gestion des utilisateurs n’est pas encore implémentée.',
      allRightsReserved: 'Tous droits réservés.',
      deleteSelected: 'Supprimer la sélection',
      confirmBulkDelete: 'Les lignes sélectionnées seront supprimées. Êtes-vous sûr ?',
      bulkDeleteSuccess: 'Les invités sélectionnés ont été supprimés avec succès',
      confirmAction: 'Êtes-vous sûr de vouloir effectuer cette action ?',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      exportToExcel: 'Exporter vers Excel',
      generateReport: 'Générer un rapport',
      exportToPDF: 'Exporter en PDF',
      participantReport: 'Rapport des invités',
      statistics: 'Statistiques',
      metric: 'Métrique',
      value: 'Valeur',
      checkedIn: 'Enregistré',
      notCheckedIn: 'Non enregistré',
      totalParticipants: 'Total des invités',
      checkInPieChart: 'Graphique en secteurs de l’état d’enregistrement',
      checkInTimeGraph: 'Graphique temporel des enregistrements',
      numberOfCheckIns: 'Nombre d’enregistrements',
      hour: 'Heure',
      alreadyCheckedIn: 'Cette personne s’est déjà enregistrée',
      confirmDeleteParticipant: 'Êtes-vous sûr de vouloir supprimer cet invité ?',
      manualCheckIn: 'Check-In Manuel',
      checkInSuccess: 'Invité enregistré avec succès.',
      importParticipants: 'Importer des invités',
      deleteExistingParticipants: 'Supprimer les participants existants',
      keepExistingParticipants: 'Conserver les participants existants',
      continue: 'Continuer',
      dragDropOrClick: 'Glissez et déposez un fichier Excel ici, ou cliquez pour en sélectionner un',
      dropFileHere: 'Déposez le fichier ici',
      resetCheckIns: 'Réinitialiser les statuts de check-in',
      checkInsReset: 'Tous les statuts de check-in ont été réinitialisés',
      deleteAllParticipants: 'Supprimer tous les participants',
      allParticipantsDeleted: 'Tous les participants ont été supprimés',
      uploadFailed: 'Échec du téléchargement du fichier',
      resetCheckInsFailed: 'Échec de la réinitialisation des statuts de check-in',
      deleteParticipantsFailed: 'Les participants n’ont pas pu être supprimés',
      invalidFileType: 'Type de fichier invalide. Veuillez télécharger un fichier .xlsx ou .xls.',
      invitationTitle: 'Invitation à l’événement',
      welcome: 'Bienvenue',
      yourQrId: 'Votre ID QR',
      downloadPDF: 'Télécharger le PDF',
      guestNotFound: 'Invité non trouvé',
      invitationNotAvailable: 'Invitation non disponible',
      loading: 'Chargement...',
      noGuestsFound: 'Aucun invité trouvé',
      participant: 'Participant',
      employee: 'Employé',
      vip: 'VIP',
      plusOne: 'Accompagnateur',
      regular: 'Régulier',
      attending: 'Je participerai',
      not_attending: 'Je ne participerai pas',
      add_plus_one: 'Ajouter un accompagnateur',
      plus_one_name: 'Nom de l’accompagnateur',
      plus_one_surname: 'Nom de famille de l’accompagnateur',
      submit_plus_one: 'Enregistrer l’accompagnateur',
      rsvp_confirmed: 'Votre participation est confirmée',
      rsvp_confirmation_message: 'Votre participation à l’événement a été enregistrée avec succès. Merci !',
      back_to_home: 'Retour à l’accueil',
      serverError: 'Une erreur de serveur s’est produite',
      alreadyRegistered: 'Cet invité est déjà enregistré',
      rsvp_not_attending: 'Enregistré comme non participant',
      please_complete_recaptcha: 'Veuillez compléter le reCAPTCHA',
      invalid_recaptcha: 'Vérification reCAPTCHA invalide',
      error_fetching_invitation: 'Impossible de récupérer les détails de l’invitation',
      error_rsvp: 'Échec de l’enregistrement RSVP',
      confirmation: 'Confirmation de participation',
      confirmationTitle: 'Confirmation',
      verifyToContinue: 'Veuillez compléter la vérification pour voir la page',
      toggleRsvp: 'Activer/Désactiver le système RSVP',
      rsvpToggled: 'Statut RSVP modifié',
      resetAll: 'Réinitialiser toutes les données',
      allDataDeleted: 'Toutes les données ont été supprimées',
      participantDeleted: 'Invité supprimé',
      rsvpEnabled: 'Système RSVP activé',
      rsvpDisabled: 'Système RSVP désactivé',
      rsvpStatusFetchFailed: 'Échec de la récupération du statut RSVP',
      rsvpToggleFailed: 'Échec de la modification du statut RSVP',
      failedRowsTitle: 'Lignes échouées',
      failedRowsMessage: 'Certaines lignes n’ont pas pu être chargées. Veuillez corriger les erreurs ci-dessous.',
      rowNumber: 'Numéro de ligne',
      retry: 'Réessayer',
      ignoreFailedRows: 'Ignorer les lignes échouées',
      retryFailed: 'Échec de la nouvelle tentative',
      invalidEmail: 'Adresse e-mail invalide ou manquante.',
      missingFirstName: 'Prénom manquant à la ligne {row}',
      missingLastName: 'Nom de famille manquant à la ligne {row}',
      missingQrId: 'ID QR manquant ou invalide à la ligne {row}',
      duplicateEmailInFile: 'Cet e-mail est utilisé dans une autre ligne du fichier (ligne : {row})',
      duplicateEmailInDb: 'Cet e-mail est déjà enregistré dans la base de données (ligne : {row})',
      duplicateQrIdInDb: 'L’ID QR est déjà utilisé par un autre utilisateur. Modifiez l’ID QR ou supprimez-le ; s’il est supprimé, un ID QR unique sera automatiquement généré pour cet utilisateur (ligne : {row})',
      plusOneNotAllowed: 'Les invités de type Accompagnateur ne peuvent pas être téléchargés via Excel (ligne : {row})',
      invalidGuestType: 'Type d’invité invalide ou manquant à la ligne {row}',
      resetEvent: 'Terminer l’événement',
      confirmResetPrompt: 'Pour réinitialiser l’événement et supprimer toutes les données des invités et utilisateurs, tapez "réinitialiser" ci-dessous.',
      resetEventSuccess: 'Événement réinitialisé avec succès. Tous les invités et utilisateurs ont été supprimés.',
      resetEventFailed: 'Échec de la réinitialisation de l’événement.',
      invalidResetInput: 'Entrée invalide. Veuillez taper "réinitialiser" pour confirmer.',
      importGuests: 'Importer des invités',
      deleteExistingGuests: 'Supprimer les invités existants',
      keepExistingGuests: 'Conserver les invités existants',
      confirmEndEvent: 'Cliquer sur ce bouton supprimera toutes les données des invités et des utilisateurs.',
      eventEndSuccess: 'Événement terminé avec succès et toutes les données supprimées',
      eventEndFailed: 'Échec de la fin de l’événement et de la suppression des données',
      endEvent: 'Terminer l’événement',
      invalidRowData: 'Données de ligne invalides',
      invalidLanguage: 'Langue non supportée',
      fileNotUploaded: 'Fichier Excel non téléchargé',
      emptyFile: 'Le fichier Excel est vide',
      missingColumn: 'Colonne requise manquante : {key}',
      deleteExistingFailed: 'Échec de la suppression des invités existants',
      invalidRetryData: 'Données de ligne invalides fournies pour la nouvelle tentative',
      checkInFailed: 'Échec du check-in',
      qrIdMissing: 'ID QR manquant',
      invalidUsername: 'Nom d’utilisateur invalide',
      invalidPassword: 'Mot de passe invalide',
      guestAddFailed: 'Échec de l’ajout de l’invité',
      guestUpdateFailed: 'Échec de la mise à jour',
      guestDeleteFailed: 'Échec de la suppression de l’invité',
      invalidInviter: 'Invitant sélectionné invalide',
      inviterHasPlusOne: 'Cet invitant a déjà un invité Accompagnateur',
      plusOneRequiresInviter: 'Un invitant doit être sélectionné pour le type Accompagnateur',
      invalidPlusOneQrId: 'L’ID plusOneQrId doit être NA ou vide pour les types Régulier ou Accompagnateur',
      guestsFetchFailed: 'Échec de la récupération des invités',
      invitersFetchFailed: 'Échec de la récupération des invitants',
      guestTypeSettings: 'Paramètres des types d\'invités',
      guestTypeSettingsDescription: 'Configurez combien d\'invités chaque type d\'invité peut inviter :',
      guestTypeSettingsSaved: 'Paramètres des types d\'invités enregistrés avec succès',
      guestTypeSettingsSaveFailed: 'Échec de l\'enregistrement des paramètres des types d\'invités',
      guestTypeSettingsFetchFailed: 'Échec de la récupération des paramètres des types d\'invités',
      invalidGuestTypeSetting: 'Paramètre de type d\'invité invalide',
      maxGuestsReached: 'Nombre maximum d\'invités atteint pour cet invitant',
      plusOneRequiresInviter: 'Le type d\'invité Accompagnateur nécessite qu\'un invitant soit sélectionné',
      invalidInviter: 'L\'invitant sélectionné n\'est pas valide ou n\'a pas la permission d\'inviter des invités',
      addUser: 'Ajouter un utilisateur',
      editUser: 'Modifier l’utilisateur',
      usernameRequired: 'Nom d’utilisateur requis',
      passwordRequired: 'Mot de passe requis',
      rolesRequired: 'Au moins un rôle doit être sélectionné',
      userUpdateSuccess: 'Utilisateur mis à jour avec succès',
      userAddSuccess: 'Utilisateur ajouté avec succès',
      userDeleteSuccess: 'Utilisateur supprimé avec succès',
      userDeleteFailed: 'Échec de la suppression de l’utilisateur',
      operationFailed: 'Échec de l’opération',
      confirmDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
      admin: 'Administrateur',
      editor: 'Éditeur',
      usereditor: 'Éditeur d’utilisateurs',
      guesteditor: 'Éditeur d’invités',
      participanteditor: 'Éditeur de participants',
      checkineditor: 'Éditeur de check-in',
      roles: 'Rôles',
      createdAt: 'Date de création',
      unauthorized: 'Accès non autorisé',
      homeDescription: 'Bienvenue dans le système de gestion d’événements du Canada ! Cette plateforme simplifie l’organisation d’événements avec des fonctionnalités telles que la gestion des invités, les processus d’enregistrement, le suivi des RSVP et le contrôle d’accès basé sur les rôles des utilisateurs. Que vous soyez administrateur, éditeur ou personnel d’enregistrement, notre système garantit une expérience fluide pour gérer les événements efficacement.',
      session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
      uploadSuccess: '{count} invités téléchargés avec succès',
      plusOneQrId_required: 'Pour le type Accompagnateur, l’identifiant QR de l’invitant est obligatoire.',
      inviter_required: 'Un invitant doit être sélectionné pour le type Accompagnateur',
      selectInviter: 'Sélectionner l’invitant',
      inviter_already_has_plus_one: 'Cet invitant a déjà un invité Accompagnateur',
      noInvitersAvailable: 'Aucun invitant approprié trouvé',
      confirmAttend: 'L’invité sera ajouté à la liste des participants.',
      invitationHeader: 'À l’occasion de la fête du Canada, l’Ambassadeur du Canada',
      ambassador: "S.E. Kevin Hamilton et Mme Tal Hamilton",
      requestPresence: 'sollicitent la participation de',
      eventDetails: 'de 18h30 à 22h00 mardi, le 1er juillet',
      location: 'À la résidence officielle, Turan Emeksiz 13, G.O.P',
      rsvpEmail: 'Pour vos questions',
      downloadTicketPrompt: "Cliquez sur le bouton ci-dessous pour télécharger votre billet.",
      downloadTicket: 'Télécharger le billet',
      plusOneTicketPrompt: 'Vous pouvez accéder au billet de votre invité {firstName} {lastName} ici.',
      downloadPlusOneTicket: 'Télécharger le billet de l’invité',
      addPlusOnePrompt: "Si vous serez accompagné d'un invité, merci de remplir le formulaire ci-dessous:",
      guestFirstName: 'Prénom de l’invité',
      guestLastName: 'Nom de famille de l’invité',
      guestEmail: 'E-mail de l’invité',
      submitGuestInfo: 'Envoyer les informations de l’invité',
      continueWithoutGuest: 'Continuer sans ajouter d’invité',
      dressCode: 'Code vestimentaire : Tenue de ville; les tenues nationales et les uniformes militaires sont les bienvenus.',
      qrCodeNotice: "Veuillez présenter votre billet et votre pièce d'identité à l'entrée.",
      noParking: "Il n'y aura pas de stationnement disponible. Cette invitation n'est pas transférable.",
      noMinors: 'Les mineurs ne seront pas admis.',
      telegramStatusFetchFailed: 'Échec de la récupération du statut Telegram',
      telegramToggleFailed: 'Échec de la modification du statut Telegram',
      telegramToggled: 'Statut des notifications Telegram mis à jour',
      telegramEnabled: 'Messages Telegram activés',
      telegramDisabled: 'Messages Telegram désactivés',
      toggleTelegram: 'Activer/Désactiver les messages Telegram',
      confirmNotAttend: 'Confirmer que l’invité ne participera pas.',
      declineMessage: 'Nous regrettons que vous ne serez pas des nôtres. ',
      downloadOwnTicket: 'Mon billet',
      submitPlusOne: 'Ajouter mon invité',
      duplicateEmailInDb: 'Cette adresse e-mail est déjà utilisée, veuillez entrer une autre adresse e-mail.',
      retryOrContact: 'Pour toutes questions: ankara.rsvp@international.gc.ca',
      rsvpClosedMessage: 'Nous sommes désolés, mais l’inscription est close. Pour toute question, veuillez contacter.',
      participantLimitReached: 'Le RSVP est ferme car la limite de participants est atteinte.',
      openRsvpLink: 'Ouvrir le lien d’invitation',
      unknownGuest: 'Invité inconnu',
      excelHeadersInstruction: 'Veuillez vous assurer que votre tableau comprend les en-têtes suivants : Prénom, Nom de famille, E-mail, Type d’invité',
      deleteAllGuests: 'Supprimer tous les invités',
      verifyPrompt: 'Veuillez vérifier',
      turnstileVerificationFailed: 'Échec de la vérification, veuillez réessayer.',
      confirmUpdateGuest:"Les informations de l'invité seront modifiées.",
      attend: "Je participerai",
      notAttend: "Je ne participerai pas",
      invalid_credentials: "Nom d'utilisateur ou mot de passe incorrect",
      guestsFirstName: "Prénom de votre invité",
      guestsLastName: "Nom de famille de votre invité",
      guestsEmail: "E-mail de votre invité",
      missingFields: "Veuillez remplir les champs manquants",
      plusone: "Plus Un",
      willAttendCount: "Nombre de participants confirmés",
  rsvpResponseRate: "Taux de réponse aux invitations",
  employeeCount: "Nombre d'employés",
  regularCount: "Nombre d'invités réguliers",
  vipCount: "Nombre de VIP",
  plusOneCount: "Nombre d'accompagnateurs",
  checkInPieChartDescription: "Ce graphique montre le nombre d'invités qui se sont enregistrés.",
  guestTypeDistribution: "Répartition des types d'invités",
  guestTypeDistributionDescription: "Montre la répartition des invités par type.",
  checkIns: "Enregistrements",
  checkInTimeGraphDescription: "Montre la répartition des enregistrements des invités dans le temps.",
  rsvpResponseChart: "Graphique des réponses aux invitations",
  notResponded: "Non répondu",
  rsvpResponseChartDescription: "Graphique des réponses aux invitations",
    loading: "Chargement de la page",
    processing: "Traitement...",
    selectGuestType: "Sélectionner le type d'invité",
    allGuests: "Tous les invités",
    export: "Exporter",
    invitedGuestInfo: "Informations sur l'invité",
    plusOneManagement: 'Gestion des accompagnateurs',
    addPlusOne: 'Ajouter un accompagnateur',
    plusOneAdded: 'Accompagnateur ajouté avec succès',
    plusOneAddFailed: 'Échec de l\'ajout de l\'accompagnateur',
    plusOneUpdated: 'Accompagnateur mis à jour avec succès',
    plusOneUpdateFailed: 'Échec de la mise à jour de l\'accompagnateur',
    plusOneDeleted: 'Accompagnateur supprimé avec succès',
    plusOneDeleteFailed: 'Échec de la suppression de l\'accompagnateur',
    plusOnesFetchFailed: 'Échec de la récupération des accompagnateurs',
    noPlusOnes: 'Aucun accompagnateur pour le moment',
    close: 'Fermer',
    addGuest: 'Ajouter un invité',
    eventTitle: "Fête d'HALLOWEEN du Club Canada",
    eventName: "Fête d'HALLOWEEN du Club Canada",
    dear: "Cher/Chère",
    invitationLine: "Vous êtes invité à la fête d'Halloween du Club Canada",
    invitationLinePrefix: "Vous êtes invité à",
    foodAndBeverage: "Nourriture et boissons disponibles à l'achat",
    eventDate: "Vendredi 31 octobre 2025",
    eventTime: "18:00 - 22:00",
    eventLocation: "À l'Ambassade du Canada à Ankara",
    registrationOpen: "",
    spaceLimited: "",
    noParking: "Il n'y a pas de stationnement disponible.",
    drinkResponsibly: "N'oubliez pas de boire de manière responsable; ne buvez pas et ne conduisez pas.",
    sociallyYours: "Cordialement,",
    pdfError: "Le PDF n'a pas pu être créé, veuillez réessayer.",
    rsvpStatusError: "Le statut RSVP n'a pas pu être récupéré, veuillez réessayer plus tard.",
    additionalGuestsInfo: "Une fois que vous RSVP, vous recevrez un deuxième e-mail pour inviter des invités supplémentaires. N'oubliez pas que toute personne invitant des invités doit être présente pour les accompagner à l'événement.",
    doNotShareLink: "Veuillez vous inscrire ici maintenant. Ne partagez pas ce lien avec qui que ce soit.",
    upTo6GuestsInfo: "Une fois que vous RSVP, vous recevrez un deuxième e-mail pour inviter jusqu'à 6 invités. N'oubliez pas que toute personne invitant des invités doit être présente pour les accompagner à l'événement.",
    volunteerSettings: 'Paramètres des bénévoles',
    volunteerSettingsDescription: 'Ajouter, modifier ou supprimer les types de bénévoles :',
    volunteerNamePlaceholder: 'Ex: barman, vente de jetons',
    addVolunteer: 'Ajouter un nouveau bénévole',
    fillEmptyVolunteerField: 'Veuillez remplir les champs vides',
    fillAllVolunteerFields: 'Veuillez remplir tous les champs',
    volunteerSettingsSaved: 'Paramètres des bénévoles enregistrés avec succès',
    volunteerSettingsSaveFailed: 'Échec de l\'enregistrement des paramètres des bénévoles',
    volunteerSettingsFetchFailed: 'Échec de la récupération des paramètres des bénévoles',
    noVolunteers: 'Aucun bénévole ajouté pour le moment. Vous pouvez en ajouter en cliquant sur le bouton plus ci-dessous.',
    invalidVolunteerSettings: 'Paramètres de bénévole invalides',
    invalidVolunteerName: 'Nom de bénévole invalide',
    toggleVolunteerSystem: 'Système de bénévoles',
    volunteerSystemToggled: 'Système de bénévoles {status}',
    volunteerSystemToggleFailed: 'Échec de la modification du statut du système de bénévoles',
    volunteerSystemStatusFetchFailed: 'Échec de la récupération du statut du système de bénévoles',
    enabled: 'Activé',
    disabled: 'Désactivé',
    eventInformationSettings: 'Paramètres des informations sur l\'événement',
    eventInformationSettingsDescription: 'Entrez les informations sur l\'événement :',
    eventNameLabel: 'Nom de l\'événement',
    eventDateLabel: 'Date de l\'événement',
    eventTimeLabel: 'Heure de l\'événement',
    eventLocationLabel: 'Lieu de l\'événement',
    eventAddressLabel: 'Adresse de l\'événement',
    eventWaiverLabel: 'Texte de la case à cocher',
    eventNamePlaceholder: 'Ex: Soirée HALLOWEEN',
    eventAddressPlaceholder: 'Ex: Aziziye, Cinnah Street no: 58, 06690 Çankaya/Ankara',
    eventDatePlaceholder: 'Ex: Vendredi 31 octobre 2025',
    eventTimePlaceholder: 'Ex: 18:00 - 22:00',
    eventLocationPlaceholder: 'Ex: À l\'ambassade du Canada à Ankara',
    eventInformationSaved: 'Informations sur l\'événement enregistrées avec succès',
    eventInformationSaveFailed: 'Échec de l\'enregistrement des informations sur l\'événement',
    eventInformationFetchFailed: 'Échec de la récupération des informations sur l\'événement',
    invalidEventInformation: 'Tous les champs doivent être remplis',
    fillAllFields: 'Veuillez remplir tous les champs',
    wouldYouLikeToVolunteer: 'Souhaitez-vous être bénévole?',
    yes: 'Oui',
    no: 'Non',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'tr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;